import { render, staticRenderFns } from "./SalaryStructureDetails.vue?vue&type=template&id=e7bace8c&scoped=true&lang=html"
import script from "./SalaryStructureDetails.vue?vue&type=script&lang=js"
export * from "./SalaryStructureDetails.vue?vue&type=script&lang=js"
import style0 from "./SalaryStructureDetails.vue?vue&type=style&index=0&id=e7bace8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bace8c",
  null
  
)

export default component.exports